import React from "react";
function AccessDenied() {
  return (
    <div className="page--data">
      <div className="flex-container justify-center comment-h">
        <div className="flex-items">
          You do not have access to view this Screen.
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
